import * as widgetActions from '../Widget/actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const alreadyTrackedActions = [];

const eventMappings = {};
eventMappings[widgetActions.ON_BACK_FROM_REP_ACTION] = [trackCancelAction];

export default function trackFindLocalRep(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCancelAction(state) {
    if (
        state.widget.lastInitiatedLocalRepIdentifier == null ||
        alreadyTrackedActions[state.widget.lastInitiatedLocalRepIdentifier] != null
    )
        return;

    alreadyTrackedActions[state.widget.lastInitiatedLocalRepIdentifier] = true;

    const actionCancelTime = state.widget.cancelTime;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: actionCancelTime
    });

    apiTracking.trackCancelAction(state, actionCancelTime);
}



// WEBPACK FOOTER //
// ./src/containers/LocalRep/tracking.js